import { environment } from "../../environments/environment";
import { ApiConfiguration } from "../api/api-configuration";

export function apiBaseUrlGetter() {

  if ((window as any).env) {
    console.debug("apiBaseUrlGetter", {
      type: "(window as any).env.API_BASE_URL)",
      value: (window as any).env.API_BASE_URL
    });
    return (window as any).env.API_BASE_URL;
  }

  if (environment) {
    console.debug("apiBaseUrlGetter", {
      type: "environment.base_url",
      value: environment.base_url
    });
    return environment.base_url;
  }

  const apiConfig: ApiConfiguration = new ApiConfiguration();
  console.debug("apiBaseUrlGetter", {
    type: "apiConfig.rootUrl",
    value: apiConfig.rootUrl
  });

  return apiConfig.rootUrl;
}
